import 'reactflow/dist/style.css';

import ReactFlow, {
  Background,
  BackgroundVariant,
  Controls,
  MiniMap,
  Panel,
} from 'reactflow';

import {
  allPromptOutputsSelector,
  useDesignerDataContext,
} from '../../../../hooks/useDesignerLogic';
import BaseModal from '../../../_molecules/BaseModal';
import { generateAllEdges } from './PromptDependencyGraph/edges/generateAllEdges';
import generateAllNodes from './PromptDependencyGraph/nodes/generateAllNodes';

type PromptDependencyGraphModalProps = {
  visible: boolean;
  onCancel: () => void;
};
const PromptDependencyGraphModal = ({
  visible,
  onCancel,
}: PromptDependencyGraphModalProps) => {
  const aiContent = useDesignerDataContext(c => c.state.localTemplate?.aiContent);
  const promptOutputs = useDesignerDataContext(allPromptOutputsSelector) || [];
  const slides = useDesignerDataContext(
    c => c.state.localTemplate?.content.slides || [],
  ).filter(r => r.type !== 'voting' && r.type !== 'podium' && r.type !== 'responsegrid');

  const promptInputs = aiContent?.promptInputs || [];
  const prompts = aiContent?.prompts || [];

  const nodes = generateAllNodes({ promptInputs, prompts, promptOutputs, slides });
  const edges = generateAllEdges({ promptInputs, prompts, promptOutputs, slides });
  return (
    <BaseModal visible={visible} onCancel={onCancel} width="80vw">
      <div style={{ height: '80vh' }}>
        <ReactFlow nodes={nodes} edges={edges} fitView>
          <Controls />
          <Background color="#ccc" variant={BackgroundVariant.Dots} gap={12} size={1} />
          <MiniMap zoomable pannable />
          <Panel position="top-left">
            <div style={{ display: 'inline-flex', flexDirection: 'column', gap: '10px' }}>
              <span style={{ backgroundColor: '#f997464d', textAlign: 'center' }}>
                Inputs
              </span>
              <span style={{ backgroundColor: '#33a0dd4d', textAlign: 'center' }}>
                Prompts
              </span>
              <span style={{ backgroundColor: '#490fea4d', textAlign: 'center' }}>
                Prompt outputs
              </span>
              <span style={{ backgroundColor: '#73ff2d66', textAlign: 'center' }}>
                Slides
              </span>
            </div>
          </Panel>
        </ReactFlow>
      </div>
    </BaseModal>
  );
};

export default PromptDependencyGraphModal;
